// Note: The new script content here was provided in Jira story VMFPW-2024.
// We can refer to that story for original script snippet if we decide to implement the script in NextJS differently.
const loadClientReviews = callback => {
  const existingScript = document.getElementById(
    'birdeye-widget-987654321116100359'
  );

  if (existingScript) {
    existingScript.remove();
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src =
    'https://birdeye.com/embed/v7/158108530018176/16/987654321116100359';

  // Note: The script ID string cannot be the same as the ID string for the Birdeye div element (e.g. bf-revz-widget-987654321116100359).
  // The widget will not display if the IDs are the same.
  script.id = 'birdeye-widget-987654321116100359';
  document.body.appendChild(script);

  script.onload = () => {
    if (callback) callback();
  };
};

export default loadClientReviews;
